// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__craL6","left":"styles_left__mwNRd"};